import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { LandingpageService } from '../services/landingpage.service';
import { languageSet } from '../language';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { AppFavorites } from '../dto/app-favorite.dto';
import { SsoUserDto } from '../dto/sso-user.dto';
import { Survey } from '../dto/survey.dto';
import Swal from 'sweetalert2';
import { SurveySubmission } from '../dto/survey-submission.dto';
import { SurveySubmissionEntry } from '../dto/survey-submission-entry.dto';
import { SurveyQuestion } from '../dto/survey-question.dto';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class StartComponent implements OnInit {
  constructor(
    public oidcSecurityService: OidcSecurityService,
    public landingpageService: LandingpageService,
    private sanitizer: DomSanitizer,
  ) { }

  userData: SsoUserDto | undefined;
  motds: any;

  myApps: any;
  myAppsFavorites: AppFavorites[] | undefined;

  floatingSurveys: Survey[] | undefined;
  modalSurveys: Survey[] | undefined;
  topSurveys: Survey[] | undefined;

  loadedSurveySubmissions: SurveySubmission[] | undefined;

  fixedItems = [
    "60589e93c907f44254a7fc52", // DE EFS GO
    "6058a132c907f4ec3ba7fc53", // DE EFS InSide
    "60589e5cc907f4692da7fc51", // AT EFS GO
    "623da0bd7aed526bc1b017ee", // HU EFS Inside
  ];

  myFavoriteApps: any;
  myNonFavoriteApps: any;

  myNews: any;
  myLanguage = languageSet.de;
  language = 'de';
  selectedFaqs: any;
  selectedApp: any;
  openFaq: any;

  unreadNews = 0;

  myNewsReads: string[] = [];

  isInnendienstOrExtern: boolean = false;

  browserLocale = window.navigator.language;

  search = '';
  searchUpdate = new Subject<string>();

  newsPerPage = 5;
  currentPage = sessionStorage.getItem('efsnews.currentpage') ? parseInt(sessionStorage.getItem('efsnews.currentpage')!) : 1;
  pagedNews: any[] = [];

  ngOnInit(): void {


    this.oidcSecurityService.userData$.subscribe(userData => {
      document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'visible';
      if (userData && userData.userData) {
        this.userData = userData.userData;


        if (this.userData!.nickname !== this.userData!.email && ((this.userData!.accountType && this.userData!.accountType === 'Innendienst') || this.userData!.nickname!.toUpperCase().startsWith('E'))) {
          this.isInnendienstOrExtern = true;
        }

        // If there is a preferredLanguage use it
        // `this.userData.preferredLanguage !== 'german'` is a temporary exception because all users are preferredLanguage at the moment
        if (userData.userData.preferredLanguage && userData.userData.preferredLanguage !== '' && userData.userData.preferredLanguage !== 'german') {
          switch (userData.userData.preferredLanguage) {
            case 'hungarian':
              this.myLanguage = languageSet.hu;
              this.language = 'hu';
              this.browserLocale = 'hu';
              break;

            case 'austrian':
              this.myLanguage = languageSet.at;
              this.language = 'de';
              this.browserLocale = 'de';
              break;
          }
        } else {
          if (!userData.userData.nickname.includes('@')) {
            switch (userData.userData.nickname.indexOf(0)) {
              case 'H':
                this.myLanguage = languageSet.hu;
                this.language = 'hu';
                this.browserLocale = 'hu';
                break;
              case 'U':
                this.myLanguage = languageSet.hu;
                this.language = 'hu';
                this.browserLocale = 'hu';
                break;
            }
          }
        }

        this.loadNewsAndMotd();
        this.loadSurveys();
        setInterval(() => { this.loadNewsAndMotd(); }, 60 * 1000);
        this.loadApps();
      }
    });

    this.searchUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(event => {
        this.search = event;
        this.loadNewsAndMotd();
      });
  }

  openSurvey(loadSurvey: Survey) {
    this.loadedSurveySubmissions = [];
    this.asyncForEach(this.topSurveys, async (survey: Survey) => {
      this.loadedSurveySubmissions?.push({
        survey: survey,
        answers: survey.questions.map((question: any) => ({
          question: question,
          value: '',
          values: [],
        })),
      })
    });

    this.loadedSurveySubmissions = [{
      survey: loadSurvey,
      answers: loadSurvey.questions.map((question: any) => ({
        question: question,
        value: '',
        values: [],
      })),
    }, ...this.loadedSurveySubmissions];

    document.getElementById(`top`)?.scrollIntoView({ behavior: 'smooth' });
  }

  loadSurveys() {
    this.landingpageService.getMySurveys(this.search).subscribe({
      next: (surveys) => {
        this.floatingSurveys = surveys.filter((survey: Survey) => survey.surveyPosition === 'floating');
        this.modalSurveys = surveys.filter((survey: Survey) => survey.surveyPosition === 'modal');
        this.topSurveys = surveys.filter((survey: Survey) => survey.surveyPosition === 'top');

        this.loadedSurveySubmissions = [];

        this.asyncForEach(this.topSurveys, async (survey: Survey) => {
          this.loadedSurveySubmissions?.push({
            survey: survey,
            answers: survey.questions.map((question: any) => ({
              question: question,
              value: question.valueType === 'range' ? '0' : '',
              values: [],
            })),
          })
        });

        this.showModalSurveys();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  async showModalSurveys() {
    await this.asyncForEach(this.modalSurveys, async (survey: Survey) => {
      // Trigger the survey function
      await Swal.fire({
        title: `Neue EFS Umfrage vorhanden!`,
        html: `<p><strong>Umfrage: ${survey.headline}</strong></p><p>${survey.description}</p>`,
        confirmButtonText: 'Umfrage öffnen',
        confirmButtonColor: '#1f2c4f',
        showCancelButton: survey.skippable && survey.skippableTimes > (survey.reads?.filter(el => el.type === 'skip').length ?? 0),
        cancelButtonText: 'Überspringen',
        allowEscapeKey: false,
        allowOutsideClick: false,
        footer: survey.skippable ? `Du kannst diese Umfrage noch ${survey.skippableTimes - (survey.reads?.filter(el => el.type === 'skip').length ?? 0)} mal überspringen.` : ``
      }).then((result) => {
        if (result.isConfirmed) {
          this.openSurvey(survey);
        } else {
          this.landingpageService.skipSurvey(survey._id!).subscribe({
            next: () => {
              console.log('Survey skipped');
            },
            error: (error) => {
              console.log(error);
            }
          });
        }
      });
    });
  }

  selectApp(app: any): void {
    this.selectedApp = app;
    this.landingpageService.getFaqByAppId(app._id).subscribe((faqs) => {
      this.selectedFaqs = faqs.result.filter((el: any) => el.visible);
    });
  }

  loadApps() {
    this.landingpageService.getMyApps().subscribe({
      next: (apps) => {
        this.myApps = apps;
        this.calculateFavoriteOrder();
        document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'hidden';
      },
      error: (error) => {
        console.log(error);
      }
    });

    this.landingpageService.getMyAppFavorites().subscribe({
      next: (favorites) => {
        this.myAppsFavorites = favorites;
        this.calculateFavoriteOrder();
        document.querySelectorAll<HTMLElement>('.efs-global-spinner')[0].style.visibility = 'hidden';
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  loadNewsAndMotd(): void {
    this.landingpageService.getMyNews(this.search).subscribe({
      next: (news) => {
        const read = news.filter((news: any) => news.read);
        const unread = news.filter((news: any) => !news.read);
        // move unread news to the top
        this.myNews = [...unread, ...read];
        this.unreadNews = this.myNews.filter((news: any) => !news.read).length;
        this.pagedNews = this.myNews.slice((this.currentPage - 1) * this.newsPerPage, this.currentPage * this.newsPerPage);
      },
      error: (err) => {
        console.log(err);
      }
    });

    this.landingpageService.getMotds().subscribe({
      next: (motds) => {
        this.motds = motds;
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  toggleFaq(faqObj: any): void {

    if (this.openFaq === faqObj) {
      this.openFaq = null;
    } else {
      this.openFaq = faqObj;
    }
  }

  logout(): void {
    this.oidcSecurityService.logoff();
  }

  equals(obj1: any, obj2: any): boolean {
    if (obj1 === null || obj1 === undefined) {
      return false;
    }

    for (const [key, value] of Object.entries(obj1)) {
      if (value + '' !== obj2[key] + '') {
        return false;
      }
    }
    return true;
  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

  safeHTML(unsafe: string): any {
    return this.sanitizer.bypassSecurityTrustHtml(unsafe);
  }

  pagesArray() {
    const pages = this.maxPage();
    return pages;
  }

  maxPage(): number {
    if (!this.myNews) {
      return 0;
    }

    return Math.ceil(this.myNews.length / this.newsPerPage);
  }

  calculateFavoriteOrder() {
    if (!this.myAppsFavorites) {
      return;
    }

    if (!this.myApps) {
      return;
    }


    this.myFavoriteApps = this.myApps.filter((app: any) => {
      return this.myAppsFavorites!.find((favorite: AppFavorites) => favorite.news_id === app._id);
    });

    // Sort myFavoriteApps according to the order in myAppsFavorites
    this.myFavoriteApps.sort((a: any, b: any) => {
      const aOrder = this.myAppsFavorites!.find((favorite: AppFavorites) => favorite.news_id === a._id)!.order;
      const bOrder = this.myAppsFavorites!.find((favorite: AppFavorites) => favorite.news_id === b._id)!.order;
      return aOrder - bOrder;
    });

    this.myNonFavoriteApps = this.myApps.filter((app: any) => {
      return !this.myAppsFavorites!.find((favorite: AppFavorites) => favorite.news_id === app._id);
    });
  }

  async submitSurvey(submission: SurveySubmission) {
    // Validate the submission
    // Reset the validation errors
    let hasErrors = false;
    submission.answers.forEach((answer: SurveySubmissionEntry) => {
      answer.validationError = undefined;
    });

    await this.asyncForEach(submission.answers, async (answer: SurveySubmissionEntry) => {
      if (
        (answer.question?.required && answer.value === '' && answer.values.length === 0 && !answer.question?.isDependencyQuestion) ||
        (answer.question?.required && answer.value === '' && answer.values.length === 0 && answer.question?.isDependencyQuestion && answer.question?.showDependencyQuestion)
      ) {
        answer.validationError = 'Dieses Feld ist erforderlich';
        hasErrors = true;
      }

      if (answer.question?.required && answer.question.valueType === 'range' && (answer.value === '' || answer.value === '0' || (answer.value as any) === 0) && (!answer.question?.isDependencyQuestion || (answer.question?.isDependencyQuestion && answer.question?.showDependencyQuestion))) {
        answer.validationError = 'Bitte wähle, durch anklicken, mindestens einen Stern aus.';
        hasErrors = true;
      }
    });

    submission.hasIssues = hasErrors;

    if (hasErrors) {
      return;
    }

    const clonedSubmission = JSON.parse(JSON.stringify(submission));

    // Filter out answers that are not shown because of dependencies
    clonedSubmission.answers = clonedSubmission.answers.filter((answer: SurveySubmissionEntry) => {
      if (answer.question?.isDependencyQuestion && !answer.question?.showDependencyQuestion) {
        return false;
      }
      return true;
    });

    this.landingpageService.submitSurvey(clonedSubmission.survey?._id!, clonedSubmission).subscribe({
      next: () => {

        Swal.fire({
          title: 'Umfrage abgegeben',
          html: `Vielen Dank für deine Teilnahme! Deine Antworten wurden erfolgreich gespeichert.`,
          icon: 'success',
        });

        this.loadSurveys();
      },
      error: (error) => {

        if (error && error.error && error.error.description === 'You are not allowed to submit this survey multiple times.') {
          Swal.fire({
            title: 'Fehler',
            html: `Du hast diese Umfrage bereits abgegeben.`,
            icon: 'error',
          });
        } else {
          Swal.fire({
            title: 'Fehler',
            html: `Beim Abschicken der Umfrage ist ein Fehler aufgetreten. Bitte versuche es in einigen Minuten erneut.<br><br>Wende dich bei Fragen an den <a href="https://support.efs-ag.com" target="_blank">EFS-IT Support</a>.`,
            footer: `${error.error.error || 'Unbekannter Fehler'} - ${error.error.message || error.error.description || 'n/a'}`,
            icon: 'error',
          });
        }
      }
    });
  }

  addToFavorites(app: any) {
    this.landingpageService.addMyAppFavorite(app._id).subscribe({
      next: () => {
        this.loadApps();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  removeFromFavorites(app: any) {
    this.landingpageService.removeMyAppFavorite(app._id).subscribe({
      next: () => {
        this.loadApps();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  moveUpFavorite(app: any) {
    if (app.order === 1) {
      return;
    }

    this.landingpageService.upMyAppFavorite(app._id).subscribe({
      next: () => {
        this.loadApps();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  moveDownFavorite(app: any) {
    if (app.order === this.myFavoriteApps.length) {
      return;
    }

    this.landingpageService.downMyAppFavorite(app._id).subscribe({
      next: () => {
        this.loadApps();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  selectPage(page: number) {
    this.currentPage = page;
    sessionStorage.setItem('efsnews.currentpage', this.currentPage.toString());
    this.pagedNews = this.myNews.slice((this.currentPage - 1) * this.newsPerPage, this.currentPage * this.newsPerPage);
  }

  nextPage(): void {
    if (this.currentPage < this.maxPage()) {
      this.currentPage++;
      sessionStorage.setItem('efsnews.currentpage', this.currentPage.toString());
      this.pagedNews = this.myNews.slice((this.currentPage - 1) * this.newsPerPage, this.currentPage * this.newsPerPage);
    }
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pagedNews = this.myNews.slice((this.currentPage - 1) * this.newsPerPage, this.currentPage * this.newsPerPage);
    }
  }

  isChecked(option: string, values: string[]): boolean {
    return values.includes(option);
  }

  checkDependency(question: SurveySubmissionEntry, submission: SurveySubmission) {
    const dependencyQuestions = submission.survey?.questions.filter((q: SurveyQuestion) => q.dependencyQuestionId === question.question?.uniqueId);

    if (!dependencyQuestions || dependencyQuestions.length === 0) {
      return;
    }

    dependencyQuestions.forEach((dependencyQuestion: SurveyQuestion) => {
      if (dependencyQuestion.dependencyMode === 'select') {
        if (question.values.includes(dependencyQuestion.dependencyValue as string)) {
          dependencyQuestion.showDependencyQuestion = true;
        } else {
          dependencyQuestion.showDependencyQuestion = false;
        }
      }

      if (dependencyQuestion.dependencyMode === 'select-multiple-some') {
        const shouldBeChecked = dependencyQuestion.dependencyValue as string[];

        if (shouldBeChecked.some(option => question.values.includes(option))) {
          dependencyQuestion.showDependencyQuestion = true;
        } else {
          dependencyQuestion.showDependencyQuestion = false;
        }
      }

      if (dependencyQuestion.dependencyMode === 'select-multiple-all') {
        const values = question.values;
        const shouldBeChecked = dependencyQuestion.dependencyValue as string[];

        if (shouldBeChecked.every(option => values.includes(option))) {
          dependencyQuestion.showDependencyQuestion = true;
        } else {
          dependencyQuestion.showDependencyQuestion = false;
        }
      }
    });
  }


  updateCheck(option: string, answer: SurveySubmissionEntry, submission: SurveySubmission, type: 'checkbox' | 'radio') {
    if (!answer.values) {
      answer.values = [];
    }

    if (type === 'radio') {
      answer.values = [option];
    } else {
      if (answer.values.includes(option)) {
        answer.values = answer.values.filter(value => value !== option);
      } else {
        answer.values.push(option);
      }
    }

    if (answer.question?.valueType === 'select' || answer.question?.valueType === 'radio' || answer.question?.valueType === 'checkbox') {
      this.checkDependency(answer, submission);
    }
  }


  async asyncForEach(array: any, callback: any): Promise<void> {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
    }
  }
}
